function updateCartTotal() {
  const cartTotalElement = document.querySelector("[data-cart-total]");
  const postcodeElement = document.querySelector("[data-customer-postcode]");
  const postcode = postcodeElement
    ? postcodeElement.getAttribute("data-customer-postcode").replace(/-/g, "")
    : null;
  const domain = window.appDomain;
  fetch("/cart.js", { credentials: "include" })
    .then((response) => response.json())
    .then((cart) => {
      if (cartTotalElement) {
        const currentCartState = localStorage.getItem("cart-status").trim();
        if (
          currentCartState === CART_STATUS.MAINTENANCE ||
          currentCartState === CART_STATUS.NORMAL_MAINTENANCE
        ) {
          cartTotalElement.innerHTML = `Total: ${formatCurrencyAfter(localStorage.getItem("total-price"))}`;
          const lineItems = cart.items.map((item) => {
            const installationQuantity =
              item.properties["Installation Quantity"] ?? 0;
            return {
              installationQuantity: Number(installationQuantity),
              variantId: `${item.variant_id}`,
              variantQuantity: item.quantity,
            };
          });

          const body = JSON.stringify({ lineItems, postcode });
          fetch(`${domain}/maintenance/cart`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body,
          })
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              const { subtotal } = data.result.data;
              const total = subtotal.totalPrice;
              localStorage.setItem("total-price", total * 100);
              const formattedPrice = formatCurrencyAfter(total * 100);
              cartTotalElement.innerHTML = `Total: ${formattedPrice}`;
            });
        } else {
          localStorage.setItem("total-price", cart.total_price / 100);
          const formattedPrice = Shopify.formatMoney(cart.total_price);
          cartTotalElement.innerHTML = `Total: ${formattedPrice}`;
        }
      }
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.productHandle = this.dataset.handle;
      this.variantIdInput.disabled = false;
      this.modalWarning = this.querySelector("#modalMaintenanceWarning");
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton
        ? this.submitButton.querySelector("span")
        : null;
      this.submitButtonConfirm = this.querySelector(
        "#btnMaintenanceWarningConfirm",
      );
      this.selectOptions = this.querySelectorAll(".dropdown-select");
      this.cardDropdownVariant = this.querySelector("card-dropdown-variant");
      if (!this.matches(".product-form")) {
        this.variants = JSON.parse(
          this.querySelector('[type="application/json"]').innerHTML,
        );
      }
      if (this.closest(".cart-area-wrap")) {
        var button =
          this.closest(".cart-area-wrap").querySelector(".toggle-cart");
        button.addEventListener("click", () => {
          const cartArea = button.nextElementSibling;
          const isVisible = cartArea.style.display === "block";
          document
            .querySelectorAll(".cart-area")
            .forEach((area) => (area.style.display = "none"));
          document
            .querySelectorAll(".product-item")
            .forEach((item) => item.classList.remove("open-quick-add"));
          cartArea.style.display = isVisible ? "none" : "block";
          button
            .closest(".product-item,.grid__item")
            .classList.add("open-quick-add");
        });
      }

      if (document.querySelector("cart-drawer"))
        this.submitButton.setAttribute("aria-haspopup", "dialog");
      this.viewerMaintenanceWarning = false;

      this.hideErrors = this.dataset.hideErrors === "true";
      this.submitButtonConfirm?.addEventListener("click", () => {
        this.viewerMaintenanceWarning = true;
        this.submitButton.click();
        this.closeModalWarning();
      });
      this.querySelector("#btnCloseMaintenanceModal")?.addEventListener(
        "click",
        () => {
          this.closeModalWarning();
        },
      );
      // this.closeModalWarning()
    }
    connectedCallback() {
      this.addEventListener("change:variant", (e) => {
        var selected_variant = this.variants.find(
          (v) => v.options.join(",") == e.detail.join(","),
        );
        if (selected_variant?.available) {
          this.variantIdInput.value = selected_variant.id;
          this.querySelector(".quick-add__submit").removeAttribute("disabled");
        } else {
          this.variantIdInput.value = "";
          this.querySelector(".quick-add__submit").setAttribute(
            "disabled",
            true,
          );
        }
      });
    }
    getFormData(type = "json") {
      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id),
        );
        formData.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      if (type === "json") {
        const formEntries = Object.fromEntries(formData.entries());
        const result = JSON.parse(
          JSON.stringify(formEntries, (key, value) => {
            if (
              typeof value === "string" &&
              value.startsWith("{") &&
              value.endsWith("}")
            ) {
              try {
                return JSON.parse(value);
              } catch (error) {
                return value;
              }
            }
            return value;
          }),
        );
        return result;
      }
      return formData;
    }

    generateFetchConfig() {
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      return config;
    }

    async getExistingLineItems() {
      const config = this.generateFetchConfig();
      const variantId = Number(this.variantIdInput.value);

      const response = await fetch(`${routes.cart_url}`, config);
      if (!response.ok) {
        return true;
      }

      const cart = await response.json();
      return cart.items.find((item) => item.variant_id === variantId);
    }
    loading(loading) {
      if (loading) {
        this.submitButton.setAttribute("aria-disabled", loading);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner")?.classList.remove("hidden");
      } else {
        this.submitButton.setAttribute("aria-disabled", loading);
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading__spinner")?.classList.add("hidden");
      }
    }

    addItemToCart() {
      const config = this.generateFetchConfig();
      const formData = this.getFormData("formData");
      config.body = formData;
      const variantId = Number(formData.get("id"));

      this.updateCartQuantity(routes.cart_add_url, config, variantId, true);
    }

    changeItemInCart(existingVariant, isMaintenance) {
      const config = this.generateFetchConfig();
      config.headers["Content-Type"] = "application/json";
      const formData = this.getFormData("json");
      const existingInstallationQuantity =
        Number(existingVariant.properties["Installation Quantity"]) ?? 0;
      const installationQuantity =
        existingInstallationQuantity +
        Number(formData["properties[Installation Quantity]"]);
      const variantQuantity =
        Number(formData.quantity) + existingVariant.quantity;

      formData.quantity = variantQuantity;
      formData.id = existingVariant.key;
      const properties = existingVariant.properties;
      if (isMaintenance) {
        properties["Installation Quantity"] = installationQuantity.toString();
      }
      formData.properties = properties;
      delete formData.form_type;
      delete formData["properties[Installation Quantity]"];
      config.body = JSON.stringify(formData);
      this.updateCartQuantity(
        routes.cart_change_url,
        config,
        existingVariant.id,
        false,
      );
    }

    updateCartQuantity(url, config, variantId, isAdd = false) {
      fetch(url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButtonText.classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          let productUpdated = response;
          if (!isAdd) {
            productUpdated = response.items.find(
              (item) => item.variant_id === variantId,
            );
            productUpdated.sections = response.sections;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: productUpdated.id,
              cartData: productUpdated,
            });
          this.error = false;
          const quickAddModal = this.closest("quick-add-modal");
          updateCartStatus(productUpdated.sections);

          updateCartTotal();
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(productUpdated);
                });
              },
              { once: true },
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(productUpdated);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading(false);
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        });
    }

    showMaintenanceWarning() {
      if (this.viewerMaintenanceWarning) {
        return true;
      }
      if (this.modalWarning) {
        this.modalWarning.classList.remove("hidden");
        this.modalWarning.style.display = "flex";
        document.querySelectorAll(".product__info-wrapper").forEach((m) => {
          m.style.position = "relative";
          m.style.zIndex = "80";
        });
      }
    }

    closeModalWarning() {
      document
        .querySelector("#modalMaintenanceWarning")
        ?.classList.add("hidden");
      document.querySelectorAll(".product__info-wrapper")?.forEach((m) => {
        m.style.position = "";
        m.style.zIndex = "";
      });
      return false;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      const currentCartState = localStorage.getItem("cart-status").trim();
      const submitMaintenance = this.submitButton.dataset.maintenance;
      if (submitMaintenance == CART_STATUS.MAINTENANCE) {
        this.showMaintenanceWarning();
      } else {
        this.viewerMaintenanceWarning = true;
      }

      if (!this.viewerMaintenanceWarning) {
        return;
      }
      if (currentCartState !== "" && submitMaintenance !== currentCartState) {
        // let canAddToCart = false;
        // const statusList = [CART_STATUS.NORMAL, CART_STATUS.NORMAL_MAINTENANCE, CART_STATUS.MAINTENANCE];
        // if (currentCartState === CART_STATUS.NORMAL_MAINTENANCE && statusList.includes(submitMaintenance)) {
        //   canAddToCart = true;
        // } else if (currentCartState === CART_STATUS.NORMAL && submitMaintenance === CART_STATUS.NORMAL_MAINTENANCE) {
        //   canAddToCart = true;
        // } else if (currentCartState === CART_STATUS.MAINTENANCE && submitMaintenance === CART_STATUS.NORMAL_MAINTENANCE) {
        //   canAddToCart = true;
        // }

        if (!isValidCartCombination(currentCartState, submitMaintenance)) {
          const currentCartStateJp = CART_STATUS_TEXT[currentCartState];
          const submitMaintenanceJp = CART_STATUS_TEXT[submitMaintenance];

          alert(
            `${submitMaintenanceJp}と${currentCartStateJp}商品は同時に購入出来ません。`,
          );
          return;
        }
      }
      this.loading(true);
      const existingVariant = await this.getExistingLineItems();
      if (existingVariant) {
        return this.changeItemInCart(
          existingVariant,
          submitMaintenance === CART_STATUS.MAINTENANCE,
        );
      }
      return this.addItemToCart();
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      if (!this.errorMessageWrapper) return;
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute("disabled", "disabled");
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute("disabled");
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector("[name=id]");
    }
  }
  customElements.define("product-form", ProductForm);
  class CardDropdownVariant extends HTMLElement {
    constructor() {
      super();
      this.dropdownMenu = this.querySelectorAll(".dropdown-menu");
      this.dropdownButtons = this.querySelectorAll(".dropdown-button");
      this.selectOptions = this.querySelectorAll(".dropdown-select");
      this.productHandle = this.dataset.handle;
      this.isAvailable = this.dataset.available == "true";
      this.parent = this.parentElement;
      this.swatches = [];
    }
    async connectedCallback() {
      this.dropdownButtons.forEach((button) => {
        button.addEventListener("click", this.openDropdown.bind(this));
      });
      this.dropdownMenu.forEach((menu) => {
        menu.querySelectorAll(".dropdown-item").forEach((item) => {
          item.addEventListener("click", () => {
            var id = item.dataset.id;
            var option = item.dataset.option;
            var select = this.querySelector(
              '.dropdown-select[data-option="' + option + '"]',
            );
            select.value = id;
            select.dispatchEvent(new Event("change"));
            menu.style.display = "none";
          });
        });
      });
      this.selectOptions.forEach((opt) => {
        opt.addEventListener("change", this.onSelectChange.bind(this));
      });
      await this.getAllSwatch();
    }

    async getAllSwatch() {
      var hasNext = false;
      var cursor = null;
      do {
        if (cursor != null) {
          var result = await this.fetchSwatch(cursor);
        } else {
          var result = await this.fetchSwatch();
        }
        hasNext = result.metaobjects.pageInfo.hasNextPage;
        cursor = result.metaobjects.pageInfo.endCursor;
        this.swatches = [...this.swatches, ...result.metaobjects.nodes];
      } while (hasNext);
      this.querySelectorAll(".dropdown-item").forEach((option) => {
        var value = option.dataset.value;
        var swatch = this.swatches.find((s) => s.fields[1].value == value);
        if (swatch) {
          option.innerHTML = `<div class="color-swatch__item" style="background-color: ${swatch.fields[0].value}"></div><span>${value}</span>`;
        }
      });
    }

    async fetchSwatch(cursor = null) {
      var query = `{ metaobjects(type: "product_color_mapping", first: 50) { pageInfo { hasNextPage endCursor } nodes { handle fields { key value }}}}`;
      if (cursor != null) {
        query = `{ metaobjects(after: "${cursor}",type: "product_color_mapping", first: 50) { pageInfo { hasNextPage endCursor } nodes { handle fields { key value }}}}`;
      }
      return await fetch(
        "https://woodone-shuei-prd.myshopify.com/api/2025-01/graphql.json",
        {
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token":
              "00e0c0894ba6406c5678ef4a26795fd4",
          },
          method: "POST",
          body: JSON.stringify({
            query,
          }),
        },
      )
        .then((res) => res.json())
        .then((res) => res.data);
    }
    onSelectChange(e) {
      var values = [];
      var options = [];
      this.selectOptions.forEach((select) => {
        values.push(select.value);
        options.push(select.options[select.selectedIndex].text);
      });
      fetch(
        `/products/${this.productHandle}?view=variant-selector&option_values=${values.join(",")}`,
      )
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          this.parentElement.innerHTML = doc.querySelector(
            ".card-dropdown-variant",
          ).innerHTML;
          this.parent.closest("product-form").dispatchEvent(
            new CustomEvent("change:variant", {
              detail: options,
            }),
          );
        });
      // this.form.querySelector('[name=id]').value = selected_variant.id
      // if(selected_variant){
      //   if(e.target.closest('.open-quick-add')){
      //     if(e.target.closest('.open-quick-add').querySelector('.product__sku')){
      //       e.target.closest('.open-quick-add').querySelector('.product__sku').innerHTML = `品番：<span class="visually-hidden">SKU:</span> ${selected_variant.sku}`
      //     }
      //   }
      // }
      // if (selected_variant.featured_image != null) {
      //   this.closest('.product-item').querySelector('.cate-item-img a img').src = selected_variant.featured_image.src
      //   this.closest('.product-item').querySelector('.cate-item-img a img').setAttribute('srcset', selected_variant.featured_image.src)
      // }
      // if (selected_variant.available) {
      //   this.querySelector('[type="submit"]').removeAttribute('disabled')
      // } else {
      //   this.querySelector('[type="submit"]').setAttribute('disabled', true)
      // }
      // this.closest('.product-item').querySelector('.period').innerText = selected_variant.sku
    }
    openDropdown(e) {
      const dropdown = e.target.nextElementSibling;

      // 他のドロップダウンを閉じる
      document.querySelectorAll(".dropdown-menu").forEach((menu) => {
        menu.style.display = "none";
      });

      // 現在のドロップダウンを切り替え
      dropdown.style.display =
        dropdown.style.display === "block" ? "none" : "block";
    }
  }
  customElements.define("card-dropdown-variant", CardDropdownVariant);
}

document.addEventListener("click", (event) => {
  const isClickInside = event.target.closest(".cart-area-wrap");
  if (!isClickInside) {
    document
      .querySelectorAll(".cart-area")
      .forEach((area) => (area.style.display = "none"));
    document
      .querySelectorAll(".product-item")
      .forEach((item) => item.classList.remove("open-quick-add"));
  }
});
